module.exports = __webpack_public_path__ + "static/media/BackWhite.a4e917e2.svg";